module.exports = __webpack_public_path__ + "static/img/18107B_2_R_20200725_LC.3c0241b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18107B_2_R_20200725_LC.png
// module id = N5Ri
// module chunks = 0